var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgResources(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.071 4.92891C17.3303 3.18811 15.0085 2.15063 12.5504 2.01516C10.0923 1.87969 7.6706 2.65575 5.74908 4.19473C3.82756 5.7337 2.54128 7.92741 2.13656 10.3558C1.73185 12.7841 2.23715 15.2764 3.55569 17.3554L2.67511 20.8567C2.6475 20.9665 2.64878 21.0815 2.67882 21.1906C2.70885 21.2998 2.76662 21.3993 2.8465 21.4794C2.92639 21.5596 3.02566 21.6178 3.13468 21.6482C3.24369 21.6787 3.35873 21.6804 3.46861 21.6532L7.14458 20.7427C9.25305 21.9134 11.7136 22.2827 14.0728 21.7826C16.4321 21.2825 18.5311 19.9466 19.9833 18.0212C21.4354 16.0957 22.1429 13.7103 21.9752 11.3045C21.8076 8.89862 20.7762 6.63439 19.071 4.92891ZM10.9999 11C10.9999 10.4477 11.4477 10 11.9999 10C12.5522 10 12.9999 10.4477 12.9999 11V16C12.9999 16.5523 12.5522 17 11.9999 17C11.4477 17 10.9999 16.5523 10.9999 16V11ZM11.9999 7C11.4477 7 10.9999 7.44772 10.9999 8C10.9999 8.55228 11.4477 9 11.9999 9C12.5522 9 12.9999 8.55228 12.9999 8C12.9999 7.44772 12.5522 7 11.9999 7Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgResources);
export default __webpack_public_path__ + "static/media/resources.5fc08572d1d571b9e0e1713c7d5b1fab.svg";
export { ForwardRef as ReactComponent };